import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>This information has been entered into our records, and you have prior authorization to dispense this request. Prior authorization does not guarantee payment. Payment is subject to patient eligibility and other Medicaid guidelines.</p>
				
				<p>The dispensing provider must make sure the diagnosis code is written on the ordering provider’s prescription. If not, please contact the ordering provider to obtain the information. It is the responsibility of the dispensing provider to maintain this information as part of their records.</p>
			</div>
		);
	}
}